export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8600.54dc3958.jpg";